'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { useColorSwatchesContext, ColorSwatchLabelPositions, ColorSwatchGradientTypes } from './color-swatches.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { className } from '../../../core/utilities/classnames.utils.js';
import { RenderComp } from '../core/render-comp.component.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)t = c[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)t = c[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
function getBackgroundUrl(e) {
    let r = (null == e ? void 0 : e.startsWith('"')) ? '' : '"';
    return e ? `url(${r}${e}${r})` : void 0;
}
t.string, t.string, t.string, t.bool, t.string, t.oneOf(ColorSwatchLabelPositions), t.oneOf(ColorSwatchGradientTypes);
const ColorSwatch = renderWithRef('ColorSwatch', null, (t, c)=>{
    let { children: l, primaryColor: i = 'transparent', secondaryColor: p, backgroundImage: u, accessibleText: b, labelPosition: d, disabled: f = false, gradient: y, title: w, style: O = {} } = t, _ = _object_without_properties(t, [
        "children",
        "primaryColor",
        "secondaryColor",
        "backgroundImage",
        "accessibleText",
        "labelPosition",
        "disabled",
        "gradient",
        "title",
        "style"
    ]), j = useColorSwatchesContext(), m = null != d ? d : null == j ? void 0 : j.labelPosition, g = _object_spread_props(_object_spread({}, _), {
        disabled: f,
        'aria-disabled': !!f,
        role: 'presentation',
        style: _object_spread_props(_object_spread({}, O), {
            backgroundColor: null != i ? i : void 0,
            color: null != p ? p : void 0,
            backgroundImage: getBackgroundUrl(u)
        })
    }), h = [
        'swan-color-swatch'
    ];
    f && h.push("swan-color-swatch-disabled"), y && h.push(`swan-color-swatch-${y}-gradient`);
    let v = className([
        'swan-color-swatch-accessible-label',
        m && 'top' !== m ? `swan-color-swatch-accessible-label-${m}` : void 0
    ]);
    return jsxs("span", {
        className: "swan-color-swatch-wrapper",
        children: [
            jsx(RenderComp, {
                root: "div",
                classNames: h,
                forwardedRef: c,
                props: g,
                children: l
            }),
            jsx(VisuallyHidden, {
                className: v,
                children: null != b ? b : w
            })
        ]
    });
});

export { ColorSwatch };
